import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndElement } from "./DndElement";

export const DndContainer = React.forwardRef(
  ({ currentDay, defaultPair, genesisData, handleGenesisSubmit, ...rest }, ref) => {
    return (
      <>
        <DndProvider backend={HTML5Backend}>
          <DndElement {...{ currentDay, defaultPair, genesisData, handleGenesisSubmit }} />
        </DndProvider>
      </>
    );
  }
);
